<template>
  <section class="content-section" id="about" ref="contentSection">
    <div class="section-header">
      <h2 class="section-title">
        <span class="title-main">关于太丰</span>
        <span class="title-sub">ABOUT TAI FENG</span>
      </h2>
      <h2>厚积工业基标立行业，太丰老字号味焕新生</h2>
      <div class="title-decoration">
        <div class="decoration-line"></div>
        <div class="decoration-dot"></div>
        <div class="decoration-line"></div>
      </div>
    </div>

    <!-- 品牌介绍 -->
    <div id="brand">
      <BrandBlock />
    </div>

    <!-- 生产基地 -->
    <div id="factory">
      <FactoryBlock />
    </div>

    <!-- 销售板块 -->
    <div id="sale">
      <SaleBlock />
    </div>

    <!-- 研发创新 -->
    <div id="innovation">
      <InnovationBlock />
    </div>

    <!-- 产品类目 -->
    <ProductsBlock id="products" />

    <!-- 发展历程 -->
    <!-- <div id="history">
      <HistoryBlock />
    </div> -->

    <!-- 公司介绍 -->
    <div id="company">
      <CompanyBlock />
    </div>

    <!-- 新闻资讯 -->
    <div id="news">
      <NewsBlock />
    </div>
  </section>
</template>

<script>
import CompanyBlock from "./contentItem/CompanyBlock.vue";
import BrandBlock from "./contentItem/BrandBlock.vue";
import ProductsBlock from "./contentItem/ProductsBlock.vue";
import HistoryBlock from "./contentItem/HistoryBlock.vue";
import NewsBlock from "./contentItem/NewsBlock.vue";
import FactoryBlock from "./contentItem/FactoryBlock.vue";
import SaleBlock from "./contentItem/SaleBlock.vue";
import InnovationBlock from "./contentItem/InnovationBlock.vue";

export default {
  name: "ContentSection",
  components: {
    CompanyBlock,
    BrandBlock,
    ProductsBlock,
    HistoryBlock,
    NewsBlock,
    FactoryBlock,
    SaleBlock,
    InnovationBlock,
  },
  mounted() {
    this.initAnimations();
  },
  methods: {
    initAnimations() {},
  },
};
</script>

<style scoped>
.content-section {
  padding: 80px 50px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  position: relative;
  overflow: hidden;
}

.content-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(to right, #9a1b1e, #b22222);
  z-index: 1;
}

.content-section::after {
  content: "";
  position: absolute;
  top: -100px;
  right: -100px;
  width: 300px;
  height: 300px;
  background: rgba(154, 27, 30, 0.03);
  border-radius: 50%;
  z-index: 0;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 2;
}

.section-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 30px;
}

.title-main {
  font-size: 3rem;
  font-weight: 800;
  color: #9a1b1e;
  text-shadow: 0 2px 8px rgba(154, 27, 30, 0.1);
  letter-spacing: 1px;
  position: relative;
  padding-bottom: 10px;
}

.title-main::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #9a1b1e;
  border-radius: 2px;
}

.title-sub {
  font-size: 1rem;
  color: #666;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: 400;
}

.title-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.decoration-line {
  width: 60px;
  height: 2px;
  background: linear-gradient(to right, transparent, #9a1b1e, transparent);
}

.decoration-dot {
  width: 8px;
  height: 8px;
  background: #9a1b1e;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(154, 27, 30, 0.4);
  animation: pulseDot 2s infinite;
}

@keyframes pulseDot {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
    box-shadow: 0 0 10px rgba(154, 27, 30, 0.4);
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
    box-shadow: 0 0 15px rgba(154, 27, 30, 0.6);
  }
}

@media (max-width: 768px) {
  .content-section {
    padding: 60px 20px;
  }

  .content-section::after {
    display: none;
  }

  .title-main {
    font-size: 2.2rem;
  }

  .title-main::after {
    width: 50px;
  }
}

@media (max-width: 576px) {
  .content-section {
    padding: 50px 15px;
  }

  .title-main {
    font-size: 1.8rem;
  }

  .title-sub {
    font-size: 0.9rem;
    letter-spacing: 2px;
  }

  .title-main::after {
    width: 40px;
    height: 2px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .content-section {
    padding: 70px 30px;
  }
}

.content-section > div[id] {
  position: relative;
  z-index: 2;
}
</style>
